import { HarmWatch } from './';

export default {
  path: '/dashboard/harmwatch',
  name: 'HarmWatch',
  childRoutes: [{ path: 'harmwatch', name: 'HarmWatch', component: HarmWatch, isIndex: true }],
};



// WEBPACK FOOTER //
// ./src/features/harmwatch/route.js